export default __webpack_public_path__ + "static/media/img20.d9812b97.jpeg";